import * as React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import { useI18n } from "../../languages/providers/I18nProvider";
import { useTheme } from "../../providers/ThemeContext";
import { HomeStyles } from "./HomeStyles";
import { GlobalStyles } from "../../styles/GlobalStyles";
import { useLangPath } from "../../hooks/useLangPath";

type HeroKeys = {
  badge: string;
  title: string;
  title2: string;
  subtitle: string;
  ctaPrimaryLabel: string;
  ctaPrimaryHref: string;
  ctaSecondaryLabel: string;
  ctaSecondaryHref: string;
};

type Props = {
  keys: HeroKeys;
  align?: "left" | "center";
};

const HeroContent = ({ keys, align = "left" }: Props) => {
  const { t } = useI18n();
  const { theme } = useTheme();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const s = HomeStyles(theme, isMobile);
  const g = GlobalStyles(theme);
  const lp = useLangPath();

  return (
    <div style={s.heroContentBox}>
      <span style={s.heroBadge}>{t(keys.badge)}</span>

      <h1
        style={{
          ...g.pageTitle,
          fontSize: isMobile ? 38 : 64,
          color: "#fff",
          marginTop: 8,
          marginBottom: 12,
          lineHeight: 1.1,
          textAlign: align === "left" ? "start" : align,
        }}
      >
        {t(keys.title)}
      </h1>

      <p
        style={{
          ...g.pageSubTitle,
          color: "#f3f3f3",
          maxWidth: 760,
          marginBottom: 18,
          textAlign: align === "left" ? "start" : align,
          marginLeft: align === "center" ? "auto" : undefined,
          marginRight: align === "center" ? "auto" : undefined,
        }}
      >
        {t(keys.title2)}
      </p>

      <div
        style={{
          ...s.heroCTA,
          ...(isMobile ? s.heroCtaSm : {}),
          justifyContent: align === "center" ? "center" : "flex-start",
        }}
      >
        {/* Primary — filled */}
        <Link to={lp(keys.ctaPrimaryHref)} style={g.btnPrimary}>
          {t(keys.ctaPrimaryLabel)}
        </Link>

        {/* Secondary — outline */}
        <Link to={lp(keys.ctaSecondaryHref)} style={s.btnSecondary}>
          {t(keys.ctaSecondaryLabel)}
        </Link>
      </div>
    </div>
  );
};

export default HeroContent;
